export default {
  labels: {
    1:[
      {x:125, y:10, value:1},
      {x:120, y:25, value:2},
      {x:115, y:40, value:3},
      {x:120, y:56, value:4},
      {x:125, y:73, value:5},
      {x:120, y:85, value:6},
      {x:115, y:100, value:7},
      {x:118, y:118, value:8},
      {x:124, y:136, value:9},
      {x:123, y:153, value:10},
      {x:128, y:170, value:11},
      {x:153, y:189, value:12},
      {x:188, y:210, value:13},
      {x:203, y:226, value:14},

      {x:412, y:10, value:1},
      {x:417, y:25, value:2},
      {x:422, y:40, value:3},
      {x:417, y:56, value:4},
      {x:412, y:73, value:5},
      {x:417, y:85, value:6},
      {x:423, y:100, value:7},
      {x:418, y:118, value:8},
      {x:412, y:136, value:9},
      {x:407, y:153, value:10},
      {x:402, y:170, value:11},
      {x:377, y:189, value:12},
      {x:342, y:210, value:13},
      {x:327, y:226, value:14},

      {x:27, y:7, value:1},
      {x:69, y:7, value:1},
      {x:469, y:7, value:1},
      {x:511, y:7, value:1},

      {x:27, y:44.5, value:2},
      {x:69, y:44.5, value:2},
      {x:469, y:44.5, value:2},
      {x:511, y:44.5, value:2},

      {x:27, y:81.5, value:3},
      {x:69, y:81.5, value:3},
      {x:469, y:81.5, value:3},
      {x:511, y:81.5, value:3},

      {x:27, y:119.5, value:4},
      {x:69, y:119.5, value:4},
      {x:469, y:119.5, value:4},
      {x:511, y:119.5, value:4},

      {x:27.5, y:166, value:5},
      {x:69, y:160.5, value:5},
      {x:469.5, y:160.5, value:5},
      {x:511, y:166, value:5},

      {x:41, y:224, value:6},
      {x:77, y:205.5, value:6},
      {x:462, y:205.5, value:6},
      {x:497, y:224, value:6},

      {x:80, y:285, value:7},
      {x:106, y:256, value:7},
      {x:439, y:249, value:7},
      {x:465, y:278, value:7},

      {x:136, y:317, value:8},
      {x:150, y:278, value:8},
      {x:398, y:276, value:8},
      {x:411, y:313, value:8},

      {x:188.9, y:327.75, value:9},
      {x:195, y:287, value:9},
      {x:355, y:286.5, value:9},
      {x:359, y:325.5, value:9},

      {x:235, y:331, value:10},
      {x:235, y:291.5, value:10},

      {x:273, y:331.5, value:11},
      {x:273, y:292, value:11},

      {x:311, y:331, value:10},
      {x:311, y:291.5, value:10},

      {x:68, y:323, value:1},
      {x:40, y:334-10, value:2},
      {x:26, y:354-20, value:3},
      {x:64, y:413-30, value:4},
      {x:34.5, y:425.5-40, value:5},

      {x:471, y:323, value:1},
      {x:499, y:334-10, value:2},
      {x:514, y:354-20, value:3},
      {x:474.5, y:413-30, value:4},
      {x:505, y:425.5-40, value:5},

      {x:2, y:64.5, value:2},
      {x:2, y:126.5, value:3},

      {x:537.5, y:64.5, value:2},
      {x:537.5, y:126.5, value:3},

      {x: 260, y: 20, value: 'Parket'},

      {x: 30, y: -15, value: '1. kat'},
      {x: 490, y: -15, value: '1. kat'},

      {x: 67, y: -15, value: 'Mezanin'},
      {x: 445, y: -15, value: 'Mezanin'},

      {x: -15, y: 100, value: 'Lože Balkon', style: 'writing-mode: vertical-lr;'},
      {x: 560, y: 100, value: 'Lože Balkon', style: 'writing-mode: vertical-lr;'},

      {x: 260, y: 350, value: 'Balkon'},
    ],

    2:[
      {x:214, y:123.5, value:1},
      {x:214, y:138.5, value:2},
      {x:214, y:153.5, value:3},
      {x:214, y:168.5, value:4},
      {x:214, y:183.5, value:5},
      {x:214, y:198.5, value:6},
      {x:214, y:213.5, value:7},
      {x:214, y:228.5, value:8},
      {x:214, y:243.5, value:9},
      {x:210, y:258.5, value:10},

      {x:330, y:123.5, value:1},
      {x:330, y:138.5, value:2},
      {x:330, y:153.5, value:3},
      {x:330, y:168.5, value:4},
      {x:330, y:183.5, value:5},
      {x:330, y:198.5, value:6},
      {x:330, y:213.5, value:7},
      {x:330, y:228.5, value:8},
      {x:330, y:243.5, value:9},
      {x:330, y:258.5, value:10},
    ],

    3:[
      {x:144, y:108.5, value:1},
      {x:144, y:123.5, value:2},
      {x:144, y:138.5, value:3},
      {x:144, y:153.5, value:4},
      {x:139, y:168.5, value:5},
      {x:139, y:183.5, value:6},
      {x:139, y:198.5, value:7},
      {x:139, y:213.5, value:8},
      {x:139, y:228.5, value:9},
      {x:135, y:243.5, value:10},
      {x:135, y:258.5, value:11},
      {x:140, y:273.5, value:12},

      {x:400, y:108.5, value:1},
      {x:400, y:123.5, value:2},
      {x:400, y:138.5, value:3},
      {x:400, y:153.5, value:4},
      {x:405, y:168.5, value:5},
      {x:405, y:183.5, value:6},
      {x:405, y:198.5, value:7},
      {x:405, y:213.5, value:8},
      {x:405, y:228.5, value:9},
      {x:405, y:243.5, value:10},
      {x:405, y:258.5, value:11},
      {x:400, y:273.5, value:12},
    ],

    4:[
      {x:214-55, y:83.5+40, value:1},
      {x:214-55, y:98.5+40, value:2},
      {x:214-55, y:113.5+40, value:3},
      {x:214-55, y:128.5+40, value:4},
      {x:214-55, y:143.5+40, value:5},
      {x:214-55, y:158.5+40, value:6},
      {x:214-55, y:173.5+40, value:7},
      {x:214-55, y:188.5+40, value:8},
      {x:214-55, y:203.5+40, value:9},
      {x:210-55, y:218.5+40, value:10},

      {x:430-55, y:83.5+40, value:1},
      {x:430-55, y:98.5+40, value:2},
      {x:430-55, y:113.5+40, value:3},
      {x:430-55, y:128.5+40, value:4},
      {x:430-55, y:143.5+40, value:5},
      {x:430-55, y:158.5+40, value:6},
      {x:430-55, y:173.5+40, value:7},
      {x:430-55, y:188.5+40, value:8},
      {x:430-55, y:203.5+40, value:9},
      {x:430-55, y:218.5+40, value:10},
    ],

    5:[
      {x:100-20, y:83.5+40, value:"I"},
      {x:100-20, y:98.5+40, value:"II"},
      {x:100-20, y:113.5+40, value:"III"},
      {x:100-20, y:128.5+60, value:"IV"},
      {x:100-20, y:143.5+60, value:"V"},
      {x:100-20, y:158.5+60, value:"VI"},
      {x:100-20, y:173.5+60, value:"VII"},
      {x:100-20, y:188.5+60, value:"VIII"},
      {x:100-20, y:203.5+60, value:"IX"},
      {x:100-20, y:218.5+60, value:"X"},
      {x:100-20, y:218.5+75, value:"XI"},
      //{x:100-20, y:218.5+90, value:"XII"},

      {x:400-40, y:83.5+40, value:"I"},
      {x:400-40, y:98.5+40, value:"II"},
      {x:400-40, y:113.5+40, value:"III"},
      {x:400-40, y:128.5+60, value:"IV"},
      {x:400-40, y:143.5+60, value:"V"},
      {x:400-40, y:158.5+60, value:"VI"},
      {x:400-40, y:173.5+60, value:"VII"},
      {x:400-40, y:188.5+60, value:"VIII"},
      {x:400-40, y:203.5+60, value:"IX"},
      {x:400-40, y:218.5+60, value:"X"},
      {x:400-40, y:218.5+75, value:"XI"},
      //{x:400-40, y:218.5+90, value:"XII"},
    ],

    6:[
      {x:14, y:108.5, value:1},
      {x:14, y:123.5, value:2},
      {x:14, y:138.5, value:3},
      {x:14, y:153.5, value:4},
      {x:14, y:168.5, value:5},
      {x:14, y:183.5, value:6},
      {x:14, y:198.5, value:7},
      {x:14, y:213.5, value:8},
      {x:14, y:228.5, value:9},
      {x:10, y:243.5, value:10},

      {x:530, y:108.5, value:1},
      {x:530, y:123.5, value:2},
      {x:530, y:138.5, value:3},
      {x:530, y:153.5, value:4},
      {x:530, y:168.5, value:5},
      {x:530, y:183.5, value:6},
      {x:530, y:198.5, value:7},
      {x:530, y:213.5, value:8},
      {x:530, y:228.5, value:9},
      {x:530, y:243.5, value:10},
    ],

    7:[
      {x:14, y:13.5, value:1},
      {x:14, y:28.5, value:2},
      {x:14, y:43.5, value:3},
      {x:14, y:58.5, value:4},
      {x:14, y:73.5, value:5},
      {x:14, y:88.5, value:6},
      {x:14, y:103.5, value:7},
      {x:14, y:118.5, value:8},
      {x:14, y:133.5, value:9},
      {x:10, y:148.5, value:10},
      {x:10, y:163.5, value:11},
      {x:10, y:178.5, value:12},
      {x:10, y:193.5, value:13},
      {x:10, y:208.5, value:14},
      {x:10, y:223.5, value:15},
      {x:10, y:238.5, value:16},
      {x:10, y:253.5, value:17},
      {x:10, y:268.5, value:18},
      {x:10, y:283.5, value:19},
      {x:10, y:298.5, value:20},
      {x:10, y:313.5, value:21},
      {x:10, y:328.5, value:22},
      {x:10, y:343.5, value:23},
      {x:10, y:358.5, value:24},

      {x:530, y:13.5, value:1},
      {x:530, y:28.5, value:2},
      {x:530, y:43.5, value:3},
      {x:530, y:58.5, value:4},
      {x:530, y:73.5, value:5},
      {x:530, y:88.5, value:6},
      {x:530, y:103.5, value:7},
      {x:530, y:118.5, value:8},
      {x:530, y:133.5, value:9},
      {x:530, y:148.5, value:10},
      {x:530, y:163.5, value:11},
      {x:530, y:178.5, value:12},
      {x:530, y:193.5, value:13},
      {x:530, y:208.5, value:14},
      {x:530, y:223.5, value:15},
      {x:530, y:238.5, value:16},
      {x:530, y:253.5, value:17},
      {x:530, y:268.5, value:18},
      {x:530, y:283.5, value:19},
      {x:530, y:298.5, value:20},
      {x:530, y:313.5, value:21},
      {x:530, y:328.5, value:22},
      {x:530, y:343.5, value:23},
      {x:530, y:358.5, value:24},
    ],
  }
}



// WEBPACK FOOTER //
// ./src/store/labels.js